import React from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Link } from "@mui/material";
import HomeSection from "./HomeSection";
import TeamLogoRail from "../playerSearch/TeamLogoRail";
import {
  getActiveNflFranchises,
  railTeamsFromNflFranchises,
} from "../../utils/nflFranchises";

const NflTeamsRow = () => {
  const navigate = useNavigate();
  const teams = railTeamsFromNflFranchises(getActiveNflFranchises());

  return (
    <HomeSection
      title="NFL teams"
      subtitle="Latest roster plus everyone who has suited up for the franchise"
      noPadding
      action={
        <Link
          component={RouterLink}
          to="/app/nfl/teams"
          underline="hover"
          color="text.secondary"
          variant="body2"
          fontWeight={600}
        >
          View all teams
        </Link>
      }
    >
      <TeamLogoRail
        teams={teams}
        onSelect={(franchiseId) => navigate(`/app/nfl/teams/${franchiseId}`)}
      />
    </HomeSection>
  );
};

export default NflTeamsRow;
